import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ServiceProviderManagementRoutes } from '../routes';
import { SystemRoleEnum, UserContextService } from '../../../../../common';
import { getMenu } from '../../../../../views/layout/sidebar/menu';
import { MenuItem } from '../../../../../views/layout/sidebar/menu.model';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserUiService {
  translate = inject(TranslateService);
  router = inject(Router);

  getUserMenu(): MenuItem[] {
    let userContext = UserContextService.UserContext();

    if (!userContext) {
      return [];
    }

    return getMenu(userContext, this.translate);
  }

  getInitialPage(): string {
    return UserUiServiceV2.getInitialPage();
  }
}

export class UserUiServiceV2 {
  static getInitialPage() {
    return '/home';
    // let userContext = UserContextService.UserContext();
    // if (!userContext) {
    //   return '';
    // }

    // if (
    //   !!userContext &&
    //   !userContext.belongsToAccountOfType('ServiceProvider') &&
    //   userContext.hasSystemRole(SystemRoleEnum.ACCOUNT_GLOBAL_ADMIN)
    // ) {
    //   return 'service-provider-management/service-provider-profiles';
    // }

    // if (userContext.hasSpecializedRole('ProviderAdmin')) {
    //   return ServiceProviderManagementRoutes.providerAdmin.initialPage;
    // }

    // if (userContext.hasSpecializedRole('CenterAdmin')) {
    //   return ServiceProviderManagementRoutes.centerAdmin.initialPage;
    // }

    // return ServiceProviderManagementRoutes.providerAdmin.initialPage;
  }
}
